import { makeStyles } from 'tss-react/mui';
import { green } from '@mui/material/colors';

const useStyles = makeStyles()(theme => ({
    root: {
        height: '100%',
        position: 'relative'
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 200
    },
    cardAction: {
        alignSelf: 'self-end'
    },
    cardActionArea: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'flex-start'
    },
    cardContent: {
        height: 'calc(100% - 290px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%'
    },
    promotionBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 104,
        height: 28,
        background: green[500],
        right: -8,
        position: 'absolute',
        top: 16,
        zIndex: 2,
        borderRadius: '4px 0 0 4px',
        'moz-box-shadow': '-2px 3px 8px #000000a1',
        '-webkit-box-shadow': '-2px 3px 8px #000000a1',
        boxShadow: '-2px 3px 8px #000000a1',
        '&::before': {
            content: '""',
            float: 'left',
            position: 'absolute',
            bottom: -8,
            right: 0,
            width: 0,
            height: 0,
            borderColor: `transparent transparent transparent ${green[800]}`,
            borderStyle: 'solid',
            borderWidth: '0 0 8px 8px',
        },
        '& span': {
            '-webkit-touch-callout': 'none', /* iOS Safari */
            '-webkit-user-select': 'none', /* Safari */
            '-khtml-user-select': 'none', /* Konqueror HTML */
            '-moz-user-select': 'none', /* Old versions of Firefox */
            '-ms-user-select': 'none', /* Internet Explorer/Edge */
            userSelect: 'none', /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
        }
    },
    media: {
        height: 320,
        width: '100%'
    },
    mediaNoStock: {
        height: 290,
        width: '100%',
        filter: theme.palette.mode === 'light' ? 'brightness(70%)' : 'brightness(50%)'
    },
    button: {
        height: '96%'
    },
    loadingContainer: {
        display: 'grid',
        justifyItems: 'center',
        alignContent: 'center',
        gap: theme.spacing(1),
        height: 458
    },
    paper: {
        padding: theme.spacing(2),
    },
    filters: {
        padding: theme.spacing(1)
    },
    [theme.breakpoints.up('sm')]: {
        media: {
            height: 290
        }
    },
    promotionContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    promotionImage: {
        width: '50px',
        marginRight: 8
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
        zIndex:1000
    },
    buttons: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 99
    },
    customChipDisabled: {
        border: "2px solid #FB7498 !important",
        transform: "scale(1.1)"
    },
    customChipDisabledWhitStock: {
        opacity: "1 !important",
        border: "2px solid #FB7498 !important",
        transform: "scale(1.2)"
    },
    arrow: {
        width: "auto",
        paddingRight: "20px",
        paddingLeft: "20px",
        background: green[500],
        height: 40,
        fontWeight: 700,
        lineHeight: '40px',
        marginBottom: 30,
        position: 'absolute',
        right: -9,
        top: 16,
        zIndex: 50,
        textAlign: 'center',
        color: "#fff",
        '&::before': {
            content: '""',
            position: 'absolute',
            left: -20,
            top: 0,
            borderTop: '20px solid transparent',
            borderBottom: '20px solid transparent',
            borderRight: `20px solid ${green[500]}`,
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            transform: 'rotate(90deg)',
            right: 0,
            top: -9,
            borderTop: `9px solid transparent`,
            borderRight: `10px solid ${green[700]}`,
            zIndex: 300
        },
    },
    oldPrice: {
        textDecoration: 'line-through',
    },
    newPrice: {
        color: green[300],
    },
    noStockChip: {
        width: "100%",
        fontSize: "1.0rem",
        height: "40px"
    },
    whitStock: {
        height: "30px",
        border: "2px solid black",
        width: "30px"
    },
    whitOutStock: {
        height: "30px",
        width: "30px",
        opacity: "50%",
        border: "2px solid black !important",
        fontSize: "7px"
    },
    iconBan: {
        height: "30px",
        width: "30px",
        color: "red",
        position: "absolute"
    },
    breadcrumbsStyles: {
        fontSize: "12px",
        marginBottom: "10px"
    }

}));

export default useStyles;